import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=480cb856&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=ts&"
export * from "./FullScreen.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=480cb856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cb856",
  null
  
)

export default component.exports